var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-banner"},[_c('div',{staticClass:"home-banner__container"},[_c('hot-banner',_vm._b({},'hot-banner',_vm.banner,false)),_vm._v(" "),(_vm.button)?_c('div',{staticClass:"home-banner__buttons"},[_c('hot-button',_vm._b({},'hot-button',_vm.button,false))],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }